import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import SupportTicketLink from '../../../../common/components/SupportTicketLink';
import SourceFileLink from './SourceFileLink';

const ExcelNameRangeNoContentMessage = ({
  apiErrorCode,
  errorCode,
  item = {},
  isPwcUser,
  t,
}) => {
  const { tab, section } = item;
  const codesError = [apiErrorCode, errorCode];

  if (isPwcUser) {
    if (codesError.some((x) => ['E1005-104', 'E1005-101'].includes(x))) {
      return (
        <>
          <div className="content-section">
            <div>{t('fileDeletedMessage')}</div>
          </div>

          <div className="content-section">
            {t('stillNotWorkingMsg')} <SupportTicketLink /> {t('forMoreHelp')}
          </div>
        </>
      );
    }

    if (codesError.some((x) => ['E1005-105'].includes(x))) {
      return (
        <>
          <div className="content-section">
            <div>{t('fileDeletedMessage')}</div>
          </div>

          <div className="content-section">
            <Trans i18nKey="stillNotWorkingWithLink">
              Still not working? You can <SupportTicketLink /> for more help.
            </Trans>
          </div>
        </>
      );
    }

    if (codesError.some((x) => ['E1005-111'].includes(x))) {
      const cannotLoadTabDeletedText = (
        <Trans
          i18nKey="cannotLoadTabDeleted"
          components={[
            <></>, // no component for "tabName"
            <SourceFileLink key="0" item={item} />,
          ]}
          values={{ tabName: tab }}
        />
      );
      return (
        <>
          <div className="content-section">
            <div>{cannotLoadTabDeletedText}</div>
          </div>

          <div className="content-section">
            <Trans i18nKey="stillNotWorkingWithLink">
              Still not working? You can <SupportTicketLink /> for more help.
            </Trans>
          </div>
        </>
      );
    }

    if (codesError.some((x) => ['E1005-904'].includes(x))) {
      const cannotLoadTabDeletedText = (
        <Trans
          i18nKey="cannotLoadTabDeleted"
          components={[<></>, <SourceFileLink key="0" item={item} />]}
          values={{ tabName: tab }}
        />
      );
      return (
        <>
          <div className="content-section">
            <div>{cannotLoadTabDeletedText}</div>
          </div>

          <div className="content-section">
            <Trans i18nKey="stillNotWorkingWithLink">
              Still not working? You can <SupportTicketLink /> for more help.
            </Trans>
          </div>
        </>
      );
    }

    return (
      <>
        <div className="content-section">
          <div>{t('objectMayHaveMoved')}</div>

          <div>
            {t('checkTheChart', { section, tab })}{' '}
            <SourceFileLink item={item} />. {t('useTheExcelAddIn')}
          </div>
        </div>

        <div className="content-section">
          <Trans
            i18nKey={
              errorCode
                ? 'ifIssueContinueCreateTicketForthisIssueWithError'
                : 'ifIssueContinueCreateTicketForthisIssue'
            }
            components={[<SupportTicketLink key="0" />]}
            values={{ errorCode }}
          />
        </div>
      </>
    );
  }

  return (
    <>
      <div className="content-section">
        <div>{t('objectMayHaveMoved')}</div>
      </div>

      <div className="content-section">
        <Trans
          i18nKey={
            errorCode
              ? 'pleaseCreateTicketForthisIssueWithError'
              : 'pleaseCreateTicketForthisIssue'
          }
          components={[<SupportTicketLink key="0" />]}
          values={{ errorCode }}
        />
      </div>
    </>
  );
};

export default withTranslation()(ExcelNameRangeNoContentMessage);
